// AI Generated Component
import { Component, Input, OnInit, OnDestroy, ElementRef, ChangeDetectorRef, AfterViewInit } from '@angular/core';
import { PolicyFormHelperService } from '@client/app/blocks/helpers/policy-form-helper/policy-form.helper.service';
import { MonEventService } from '@monsido/services/mon-event/mon-event.service';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { MON_EVENTS } from '@monsido/core/constants/mon-events.constant';
import { FormGlobalPolicyDialogRuleComponent } from '@client/app/forms/global-policy/dialogs/rule/rule.component';
import { FormUtils } from '@client/ng2/shared/form-utils';

@Component({
    standalone: false,
    selector: 'form-global-policy-rules',
    template: `
<form #policyRules="ngForm" class="policy-form-rules h-100">
    <div class="row min-height d-flex align-items-stretch">
        <div class="col-sm-22 col-md-20 col-lg-18 pl-sm-6 bg-white">
            <form-global-policy-boxes [(tab)]="boxTab"
                                      [elements]="elements"
                                      [policy]="policy"
                                      (mouseover)="onPolicyBoxesMouseOver()"
                                      (mouseout)="onPolicyBoxesMouseOut()"
            >
            </form-global-policy-boxes>
        </div>
        <div class="col-sm-26 col-md-28 col-lg-30 pl-sm-0 bg-light-grey">
            <div class="px-3 pl-sm-6 position-relative">
                <div class="row pt-6">
                    <div class="col-24 col-md-34">
                        <div class="pb-3 ml-1 mb-2 font-size-1-75">
                            <span translate>Policy rules</span>
                        </div>
                    </div>
                    <div class="col-24 col-md-14 d-flex align-items-center justify-content-end">
                        <label class="col-form-label text-bold pr-2" translate>Rule operator</label>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input"
                                   name="policy_rule_operator"
                                   type="radio"
                                   id="policy_rule_operator_or"
                                   value="or"
                                   [(ngModel)]="policy.rules_operator">
                            <label class="form-check-label" for="policy_rule_operator_or" translate>Or</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input"
                                   name="policy_rule_operator"
                                   type="radio"
                                   id="policy_rule_operator_and"
                                   value="and"
                                   [(ngModel)]="policy.rules_operator">
                            <label class="form-check-label" for="policy_rule_operator_and" translate>And</label>
                        </div>
                    </div>
                </div>
                <ul class="list-unstyled drop-zone mb-0 py-2 mx-1 row">
                    <li *ngFor="let rule of policy.rules; trackBy: trackByIndex; let $index = index" class="col-48">
                        <div class="d-flex align-items-center rules-fixed-height-container">
                            <div
                                class="rule-content btn btn-border-radius btn-secondary"
                                (click)="editRule(rule, $index)">
                                <div class="icon-container">
                                    <span *ngFor="let icon of elements[findIndexOfElement(rule.type)]?.icons"
                                        class="{{icon}} fa-2x outer-r-mini inline-block">
                                    </span>
                                </div>
                                <div class="text-left text-ellipsis mr-auto">
                                    <span translate>Rule</span>:
                                    {{rule.name}}
                                    <div class="text-dark-grey text-ellipsis">
                                        <span *ngIf="isRuleTypetext(rule.type)" class="inline-block pr-2">
                                            <span class="fas" [ngClass]="{'fa-toggle-on': !rule.inverse, 'fa-toggle-off': rule.inverse}">
                                            </span>&nbsp;
                                            <span translate>Contains</span>
                                        </span>
                                            <span *ngIf="isRuleTypetext(rule.type)" class="inline-block pr-2">
                                            <span class="fas fa-text-height"></span>&nbsp;
                                            <span translate *ngIf="rule.case_sensitive">Case sensitive</span>
                                            <span translate *ngIf="!rule.case_sensitive">Not case sensitive</span>
                                        </span>
                                            <span *ngIf="rule.operator" class="inline-block pr-2">
                                            <span class="fas fa-info-circle"></span>&nbsp;
                                            {{getOperatorTranslation(rule)}}: {{rule.query}}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="text-right rule-delete ml-auto">
                                <button
                                        [monModalConfirm]="'Are you sure you want to remove the rule <strong>' + rule.name + '</strong>?' | translate"
                                        (monModalConfirmAction)="deleteRule($index)"
                                        role="button"
                                        [attr.aria-label]="'Remove rule from policy' | translate"
                                        class="btn btn-secondary btn-border-radius"
                                        [ngbTooltip]="'Remove rule' | translate"
                                        tooltipClass="text-ellipsis"
                                        [triggers]="'focus hover'"
                                        placement="left"
                                        (click)="$event.preventDefault()">
                                    <span class="fas fa-trash-alt fa-fw"></span>
                                </button>
                            </div>
                        </div>
                        <p class="text-grey text-uppercase mt-2" *ngIf="$index !== (policy.rules.length - 1)">
                            {{ policy.rules_operator || 'or'}}
                        </p>
                    </li>
                </ul>
                <span id="scrollToPolicyBottom"></span>
                <ul class="list-unstyled drop-zone mt-2 mb-4 bg-light-grey"
                    (dragover)="onDragOver($event)"
                    (dragleave)="onDragLeave($event)"
                    (drop)="onDrop($event)">
                    <li class="dndPlaceholder text-center my-0 mx-1 position-relative"
                        id="rulePolicyMenu"
                        data-test="add-rule-button"
                        aria-haspopup="true"
                        aria-controls="policyRulesMenu"
                        [attr.aria-expanded]="showElementsDropdown"
                        (click)="onAddRuleToPolicyClick($event)"
                        role="button"
                        ngbTooltip="{{ tooltip }}"
                        [tooltipClass]="'text-ellipsis'"
                        [triggers]="'focus hover'"
                        placement="bottom"
                        [ngClass]="{'drop-hover': isDragOver || isMouseOver}"
                        >
                        <span class="fas fa-plus-square fa-lg"></span>
                        <strong translate>Add rule to policy</strong>
                        <div class="policy-rules-menu-anchor"
                             (clickOutside)="hideElementsDropdown()"
                             [delayClickOutsideInit]="true"
                             [ngStyle]="policyRulesMenuStyleObj"
                             *ngIf="showElementsDropdown">
                            <mon-scrollable-dropdown-menu
                                    [monId]="'policyRulesMenu'"
                                    [monLabelledBy]="'rulePolicyMenu'"
                                    [monMenuItems]="monMenuItems"
                                    (monOnSelect)="onDropdownMenuItemSelect($event)"
                                    (monOnClose)="hideElementsDropdown()"
                            ></mon-scrollable-dropdown-menu>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</form>
    `,
})
export class FormGlobalPolicyRulesComponent implements OnInit, OnDestroy, AfterViewInit {
    @Input() policy: any;
    @Input() boxTab: any;
    @Input() containerForm: any;

    elements: any[] = [];
    isDragOver = false;
    isMouseOver = false;
    showElementsDropdown = false;
    policyRulesMenuStyleObj: any = {};
    tooltip = '';
    monMenuItems: any[] = [];

    private dragStartListener: any;
    private dragEndListener: any;
    private dragCounter = 0;

    private RULE_POLICY_DROPDOWN_MENU_WIDTH = 210;
    private RULE_POLICY_DROPDOWN_MENU_HEIGHT = 275;
    private RULE_POLICY_DROPDOWN_MENU_OFFSET = 10;

    constructor (
        private policyFormHelperService: PolicyFormHelperService,
        private monEventService: MonEventService,
        private translateService: TranslateService,
        private elementRef: ElementRef,
        private cdRef: ChangeDetectorRef,
    ) {}

    ngOnInit (): void {
        this.activate();
        this.getElements();
    }

    ngAfterViewInit () {
        this.cdRef.detectChanges();
    }

    ngOnDestroy (): void {
        this.monEventService.remove(this.dragStartListener);
        this.monEventService.remove(this.dragEndListener);
    }

    trackByIndex (index: number): number {
        return index;
    }

    onDragOver (event: DragEvent): void {
        const data = event.dataTransfer?.getData('application/json');
        if (data || event.dataTransfer?.types.includes('application/json')) {
            event.preventDefault();
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            event.dataTransfer!.dropEffect = 'copy';
        }
    }

    onDragLeave (event: DragEvent): void {
        // Handle drag leave with proper event target checking
        const target = event.target as HTMLElement;
        const relatedTarget = event.relatedTarget as HTMLElement;

        // Only set isDragOver to false if we're actually leaving the drop zone
        if (!target.closest('.drop-zone') || !relatedTarget?.closest('.drop-zone')) {
            this.isDragOver = false;
        }
    }

    onDrop (event: DragEvent): void {
        event.preventDefault();
        this.isDragOver = false;

        try {
            const data = event.dataTransfer?.getData('application/json');
            if (data) {
                const dragData = JSON.parse(data);
                if (dragData.type) {
                    this.addRuleToPolicy(dragData.type);
                }
            }
        } catch (error) {
        }
    }

    editRule (rule: any, index: number): void {
        const params = {
            body: FormGlobalPolicyDialogRuleComponent,
            data: { rule: rule },
        };
        const callback = (editedRule: any) => {
            if (editedRule && typeof editedRule === 'object') {
                this.policy.rules[index] = editedRule;
                FormUtils.markFormAsDirty(this.containerForm);
            } else {
                if (!rule.hasOwnProperty('name') || rule.name === '' || rule.name === null || rule.name === undefined) {
                    this.deleteRule(index, true);
                }
            }
        };
        this.monEventService.run(MON_EVENTS.LOAD_DIALOG, { params, callback });
    }

    deleteRule (index: number, skipSetFormDirty?: boolean): void {
        this.policy.rules.splice(index, 1);
        if (!skipSetFormDirty) {
            FormUtils.markFormAsDirty(this.containerForm);
        }
    }

    findIndexOfElement (ruleType: any): number {
        let result = -1;
        for (let i = 0; i < this.elements.length; i++) {
            if (this.elements[i].type === ruleType) {
                result = i;
                break;
            }
        }
        return result;
    }

    getOperatorTranslation (rule: any): string {
        this.policyFormHelperService.setRuleType(rule.type);
        const operatorOption = this.policyFormHelperService.getOptionsByRuleType().find((operator: any) => {
            return operator.type === rule.operator;
        });

        return operatorOption ? operatorOption.translation : '';
    }

    isRuleTypetext (type: any): boolean {
        return this.policyFormHelperService.isRuleTypeText(type);
    }

    onElementSelect (data: any): void {
        this.hideElementsDropdown();
        if (!data) {
            return;
        }
        const element = this.elements[data.id];
        if (element) {
            this.addRuleToPolicy(element.type);
        }
    }

    onAddRuleToPolicyClick (event: any): void {
        if (this.showElementsDropdown) {
            return;
        }
        this.boxTab = 'rule';
        this.policyRulesMenuStyleObj = this.calculateRuleMenuPosition(event);
        this.showElementsDropdown = true;
    }

    hideElementsDropdown (): void {
        this.showElementsDropdown = false;
    }

    onDropdownMenuItemSelect (event: any): void {
        this.hideElementsDropdown();
        this.onElementSelect(event.data);
    }

    onPolicyBoxesMouseOver (): void {
        if (this.boxTab === 'rule') {
            this.isMouseOver = true;
        } else {
            this.isMouseOver = false;
        }
    }

    onPolicyBoxesMouseOut (): void {
        if (this.boxTab === 'rule') {
            this.isMouseOver = false;
        } else {
            this.isMouseOver = false;
        }
    }

    private addRuleToPolicy (type: string): void {
        const newRule = { type: type };
        this.policy.rules.push(newRule);
        const index = this.policy.rules.length - 1;
        this.editRule(newRule, index);
    }

    private activate (): void {
        this.policy.rules_operator = this.policy.rules_operator || 'or';
        this.showElementsDropdown = false;
        this.policyRulesMenuStyleObj = {};
        if (!this.policy.rules) {
            this.policy.rules = [];
        }

        this.setupListeners();
        this.tooltip = this.translateService.getString('Click here or drag a rule to this area');
    }

    private setupListeners (): void {
        // Listen for drag start events from element component
        this.dragStartListener = this.monEventService.addListener('dragStart' as any, (data: any) => {
            this.isDragOver = true;
        });

        // Listen for drag end events
        this.dragEndListener = this.monEventService.addListener('dragEnd' as any, () => {
            this.isDragOver = false;
        });
    }

    private getElements (): void {
        this.policyFormHelperService.setPolicySubject(this.policy.subject);
        this.elements = this.policyFormHelperService.getSubjectTypeOptions();
        this.monMenuItems = [];
        for (let i = 0; i < this.elements.length; i++) {
            this.monMenuItems.push({
                icons: this.elements[i].rawIcons,
                text: this.elements[i].translation,
                id: i,
            });
        }
        this.policy.rules = this.policy.rules.filter((rule: any) => {
            return this.findIndexOfElement(rule.type) > -1;
        });
    }

    private calculateRuleMenuPosition (nativeEvent: any): any {
        if (!this.elementRef.nativeElement) {
            return {};
        }
        const el = this.elementRef.nativeElement.querySelector('#rulePolicyMenu');
        if (!el) {
            return {};
        }
        const rect = el.getBoundingClientRect();
        let left = nativeEvent.clientX - rect.left + this.RULE_POLICY_DROPDOWN_MENU_OFFSET;
        let top = nativeEvent.clientY - rect.top + this.RULE_POLICY_DROPDOWN_MENU_OFFSET;
        if (nativeEvent.clientX + this.RULE_POLICY_DROPDOWN_MENU_WIDTH + this.RULE_POLICY_DROPDOWN_MENU_OFFSET > window.innerWidth) {
            left = rect.width - this.RULE_POLICY_DROPDOWN_MENU_WIDTH;
        }
        if (nativeEvent.clientY + this.RULE_POLICY_DROPDOWN_MENU_HEIGHT > window.innerHeight) {
            top = top - this.RULE_POLICY_DROPDOWN_MENU_OFFSET * 2 - this.RULE_POLICY_DROPDOWN_MENU_HEIGHT;
        }
        return {
            left: left + 'px',
            top: top + 'px',
            width: this.RULE_POLICY_DROPDOWN_MENU_WIDTH + 'px',
            height: this.RULE_POLICY_DROPDOWN_MENU_HEIGHT + 'px',
        };
    }
}
